import * as React from 'react';
import { ButtonGroup } from '@material-ui/core';

const CustomButtonGroup = (props) => {
    return <ButtonGroup {...props} />;
};

export { CustomButtonGroup as ButtonGroup };
